import { render, staticRenderFns } from "./ListConsignes.vue?vue&type=template&id=2528895a&scoped=true&"
import script from "./ListConsignes.vue?vue&type=script&lang=ts&"
export * from "./ListConsignes.vue?vue&type=script&lang=ts&"
import style0 from "./ListConsignes.vue?vue&type=style&index=0&id=2528895a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528895a",
  null
  
)

export default component.exports